import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pigmyremittance-grid',
  templateUrl: './pigmyremittance-grid.component.html',
  styleUrls: ['./pigmyremittance-grid.component.css']
})
export class PigmyremittanceGridComponent implements OnInit {
  title = "Pigmy remittance"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/general-transaction/pigmyremittance-grid/pigmyremittance-grid.component.ts